import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as platform from 'platform';
import jstz from 'jstz';
import Spinner from 'react-spinner';
import BaseModal from './BaseModal';
import { reportError } from '../../actions/reportError';

require('./Modal.scss');
require('./ReportErrorModal.scss');

function mapStateToProps (state, ownProps) {
    return {
        open: state.modal.isReportErrorOpen,
        reportInProgress: state.reportError.inProgress,
        reportSubmitted: state.reportError.submitted
    };
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        reportError: (description) => dispatch(reportError(description))
    };
}

class ReportErrorModal extends Component {
    constructor (props) {
        super(props);

        this.state = {
            description: '',
            formError: false
        };
    }

    _handleTextChange (evt) {
        this.setState({description: evt.target.value});
    }

    _handleSubmitClick () {
        let stateUpdate = {formError: true};

        if (this.state.description) {
            this.props.reportError(this.state.description);
            stateUpdate = {
                description: '',
                formError: false
            };
        }

        this.setState(stateUpdate);
    }

    _renderSubmittedView () {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <h3>Your issue has successfully been reported to technical support.</h3>
                        <p>Thank you for your feedback. You should hear from technical support soon.</p>
                    </div>
                </div>
                <div className="row buttons">
                    <div className="col-xs-6 col-sm-4 col-sm-offset-4">
                        <button
                            className="btn-submit"
                            onClick={() => this.props.closeModal()}
                        >OK</button>
                    </div>
                </div>
            </div>
        );
    }

    _renderWaitView () {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <h3>Your issue is being reported to technical support.</h3>
                        <p>Please don&apos;t close the browser window until the report is submitted.</p>
                    </div>
                    <div className="col-xs-12"><Spinner /></div>
                </div>
            </div>
        );
    }

    _renderForm () {
        const inputClass = (this.state.formError && !this.state.description)
            ? 'error-highlight'
            : '';

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-sm-12">
                        <h3>Please describe the bug or issue in detail.</h3>
                        <p>If you are reporting a bug, please describe what you were doing immediately before experiencing the bug.</p>
                        <textarea
                            onChange={(evt) => this._handleTextChange(evt)}
                            placeholder="Describe the bug or issue..."
                            value={this.state.description}
                            className={inputClass}
                        />
                    </div>
                </div>
                <div className="row buttons">
                    <div className="col-xs-6 col-sm-4 col-sm-offset-2">
                        <button
                            className="btn-delete"
                            onClick={() => this.props.closeModal()}
                        >Cancel</button>
                    </div>
                    <div className="col-xs-6 col-sm-4">
                        <button
                            className="btn-submit"
                            onClick={() => this._handleSubmitClick(this.state.description)}
                        >Submit</button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const version = process.env.VERSION;
        const userAgent = platform.description;
        const locale = (navigator.language || navigator.browserLanguage).split('-')[0];
        const timezone = jstz.determine().name();
        let content = "";

        if (this.props.reportSubmitted) {
            content = this._renderSubmittedView();
        } else if (this.props.reportInProgress) {
            content = this._renderWaitView();
        } else {
            content = this._renderForm();
        }

        return (
            <BaseModal
                isOpen={this.props.open}
                hasCloseButton={true}
                renderWithHeader={true}
                title='Report an issue or bug'
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => this.props.closeModal()}
                containerClass="defaultModal report-error-modal"
            >{content}</BaseModal>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportErrorModal);



// WEBPACK FOOTER //
// ./app/components/Modals/ReportErrorModal.jsx